<div class="left-card pb-5">
  <div class="right" *ngIf="currentTab === 1" (click)="goToCenter()">
    <span>{{ "presentation" | translate }}</span>
    <i class="fas fa-chevron-right"></i>
  </div>
  <div class="width-card">
    <div class="row pt-5">
      <div class="col-12 col-md-3">
        <div class="top-image mb-3 mb-md-0">
          <img
            [src]="profileImage"
            *ngIf="this.publicCardData.urlFotoPerfil !== ''"
          />
          <img
            src="assets\img\imagge.jpg"
            *ngIf="
              this.publicCardData.urlFotoPerfil === '' ||
              this.publicCardData.urlFotoPerfil === null
            "
            class="img-fluid"
          />
        </div>
      </div>
      <div class="col-12 col-md-9">
        <h1 class="break-word">{{ publicCardData.titulo }}</h1>
        <p class="break-word">{{ publicCardData.descripcion }}</p>
        <!-- <button mat-stroked-button class="mt-3" (click)="openContact()">
        {{ "contact_me" | translate }}
      </button> -->
        <!-- <a
        href="{{
          'https://api.whatsapp.com/send?phone=' +
            publicCardData.claveTelefono +
            this.publicCardData.telefono +
            '&text=Hola, Nececito mas informacion!'
        }}"
        *ngIf="this.publicCardData.telefono !== ''"
        style="font-size: 24px"
        >{{ "contact_me" | translate }}
        <i class="fab fa-whatsapp ml-2" style="font-size: 20px"></i>
      </a> -->
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 mb-3">
        <h1>{{ "contact" | translate }}</h1>
        <hr />
      </div>
      <div class="col-12 col-md-4">
        <a (click)="openContact()">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-envelope contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "email_address" | translate }}</h2>
              <p>
                {{ publicCardData.correo }}
              </p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-4">
        <a [href]="getbuildShared('phone')" target="_blank">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-mobile-alt contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "phone" | translate }}</h2>
              <ng-container
                *ngIf="
                  publicCardData.claveTelefono != '' &&
                  publicCardData.telefono !== ''
                "
              >
                <p>
                  +{{
                    publicCardData.claveTelefono + " " + publicCardData.telefono
                  }}
                </p>
              </ng-container>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-4">
        <a [href]="getbuildShared('maps')" target="_blank">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-map-marker-alt contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "address" | translate }}</h2>
              <p>{{ publicCardData.domicilio }}</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 mb-3">
        <h1>{{ "social_networks" | translate }}</h1>
        <hr />
      </div>

      <div
        class="col-12 col-md-4 mt-2 mb-2"
        *ngFor="let network of socialNetworksList"
      >
        <a [href]="network.urlRedSocial" target="_blank">
          <div class="social-media" style="margin: 8px 0">
            <i
              class="fab fa-facebook-square"
              *ngIf="network.redSocial === 'Facebook'"
            ></i>
            <i
              class="fab fa-instagram-square"
              *ngIf="network.redSocial === 'Instagram'"
            ></i>

            <!-- <i
              class="fab fa-twitter-square"
              *ngIf="network.redSocial === 'Twitter'"
            ></i> -->

            <i class="fa fa-twitter"
            *ngIf="network.redSocial === 'X.com'"
            ></i>
            
            <!-- <i                        
              class="fa fa-twitter"
              *ngIf="network.redSocial === 'Twitter'"
            ></i> -->

            <i
              class="fab fa-linkedin"
              *ngIf="network.redSocial === 'LinkedIn'"
            ></i>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="50px"
              height="50px"
              style="fill: var(--page_color); margin: -2px 0 8px -7px"
              *ngIf="network.redSocial === 'TikTok'"
            >
              <path
                d="M 6 3 C 4.3550302 3 3 4.3550302 3 6 L 3 18 C 3 19.64497 4.3550302 21 6 21 L 18 21 C 19.64497 21 21 19.64497 21 18 L 21 6 C 21 4.3550302 19.64497 3 18 3 L 6 3 z M 12 7 L 14 7 C 14 8.005 15.471 9 16 9 L 16 11 C 15.395 11 14.668 10.734156 14 10.285156 L 14 14 C 14 15.654 12.654 17 11 17 C 9.346 17 8 15.654 8 14 C 8 12.346 9.346 11 11 11 L 11 13 C 10.448 13 10 13.449 10 14 C 10 14.551 10.448 15 11 15 C 11.552 15 12 14.551 12 14 L 12 7 z"
              />
            </svg>
            <h2>{{ network.redSocial }}</h2>
          </div>
        </a>
      </div>
      <hr class="mt-3" />
    </div>

    <div class="row mt-5">
      <div class="col-12 text-center">
        <h1 class="mb-3">{{ "scan_my_card" | translate }}</h1>
        <ngx-qrcode [value]="urlQR" id="qr" (click)="addEventQr()">
        </ngx-qrcode>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 text-center">
        <h1>{{ "share" | translate }}</h1>
      </div>
      <div class="col-12">
        <div class="shared">
          <a [href]="getbuildShared('facebook')" target="_blank">
            <div
              class="cl-facebook"
              [tooltip]="'share_by_facebook' | translate"
              placement="top"
            >
              <i class="fab fa-facebook-f"></i>
            </div>
          </a>

          <a [href]="getbuildShared('whatssapp')" target="_blank">
            <div
              class="cl-whatssapp"
              [tooltip]="'share_by_whatsapp' | translate"
              placement="top"
            >
              <i class="fab fa-whatsapp"></i>
            </div>
          </a>

          <a [href]="getbuildShared('twitter')" target="_blank">
            <!-- class="cl-twitter" -->
            <div
              [tooltip]="'share_by_twitter' | translate"
              placement="top"
            >
              <!-- <i class="fab fa-twitter"></i> -->

            <i class="fa fa-twitter"></i>

            </div>
          </a>

          <a [href]="getbuildShared('sms')" target="_blank">
            <div
              class="cl-sms"
              [tooltip]="'share_by_sms' | translate"
              placement="top"
            >
              <i class="far fa-comments"></i>
            </div>
          </a>

          <div
            ngxClipboard
            [cbContent]="urlQR"
            (click)="showSuccess()"
            class="cl-copy"
            [tooltip]="'copy_site' | translate"
            placement="top"
          >
            <i class="far fa-copy"></i>
          </div>
        </div>
      </div>

      <!-- >> -->
      <div class="row">
        <div class="col-12 text-center mt-3 mb-1">
          <h2>{{ "save_contact_in_phone" | translate }}</h2>
        </div>
        <div class="col-12 text-center mt-3 mb-3 shared">
          <div
            (click)="buildVCard()"
            class="cl-movil"
            [tooltip]="'save_contact' | translate"
            placement="top"
          >
            <i class="fas fa-mobile-alt"></i>
          </div>
        </div>

        <!-- <div class="col-12 text-center mt-3 mb-1">
          <h2>{{ "add_to_homescreen" | translate }}</h2>
        </div>
        <div class="col-12 text-center mt-3 mb-3">
          <a
            href="https://drive.google.com/file/d/1pqV76jSfasHkNOCf5j7CBcImX07rVUzy/view"
            target="_blank"
          >
            <i
              class="fab fa-android"
              style="font-size: 60px; margin-right: 32px"
            ></i>
          </a>
          <a
            href="https://drive.google.com/file/d/1F758-ZXxupFrp0w1_G0dUH85VayENtwP/view"
            target="_blank"
          >
            <i class="fab fa-apple" style="font-size: 60px"></i>
          </a>
        </div> -->
      </div>

      <!-- <ng-container *ngIf="publicCardData.crearTarjeta">
        <div
          class="col-12 text-center"
          *ngIf="sessionActive && userId === publicCardData.idUsuario"
        >
          <div class="shared">
            <div class="cl-login" placement="top" [routerLink]="['/login']">
              <i class="fas fa-magic"></i>
            </div>
          </div>

          <div
            style="
              width: 0;
              height: 0;
              border-right: 10px solid transparent;
              border-top: 10px solid transparent;
              border-left: 10px solid transparent;
              border-bottom: 15px solid #000000;
              margin: auto;
            "
          ></div>
          <small
            style="
              padding: 20px;
              background: black;
              padding-top: 5px;
              padding-bottom: 5px;
              border-radius: 5px;
              color: white;
            "
            >{{ "edit" | translate }}
          </small>
        </div>
        <div class="col-12 text-center" *ngIf="!sessionActive">
          <div class="shared">
            <div class="cl-login" placement="top" [routerLink]="['/login']">
              <i class="fas fa-sign-in-alt"></i>
            </div>
          </div>
          <div
            style="
              width: 0;
              height: 0;
              border-right: 10px solid transparent;
              border-top: 10px solid transparent;
              border-left: 10px solid transparent;
              border-bottom: 15px solid #000000;
              margin: auto;
            "
          ></div>
          <small
            style="
              padding: 20px;
              background: black;
              padding-top: 5px;
              padding-bottom: 5px;
              border-radius: 5px;
              color: white;
            "
            >{{ "login" | translate }}
          </small>
        </div>
      </ng-container> -->

      <h5 class="text-center mt-5">Powered by 3DCourtney</h5>
    </div>
  </div>
</div>
